import React, { useState } from 'react'
import { FaDiscord, FaTwitter } from 'react-icons/fa'
import { useStateValue } from './context/StateProvider'
import me from '../Assets/me.png'
const Header = () => {
  const [{ count }, dispatch] = useStateValue()



  return (
    <div className=' w-full h-[10vh] items-center px-20 py-5 justify-between flex'>
      <div className='flex gap-4 text-[30px] '>
{/*         <FaDiscord className='text-violet-400' />
 */}        <a href='https://twitter.com/DustRaffle'>
          <FaTwitter className='text-[#0073C1]' />
        </a>
        <a href='https://magiceden.io/marketplace/raffle_dust'>
          <img className='w-10' src={me}/>
        </a>
      </div>

      
    </div>
  )
}

export default Header